// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".relation-list-item[data-v-24e2ef15]{padding:1rem 1.25rem}.relation-list-item+.relation-list-item[data-v-24e2ef15]{border-top:1px solid #eee}.relation-name-row[data-v-24e2ef15]{display:flex;align-items:center;flex-wrap:wrap}", ""]);
// Exports
module.exports = exports;
